var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-dropdown',{ref:_vm._uid,attrs:{"showValueId":true},on:{"onChange":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }